varying float z;
uniform float u_time;
void main() {
    z = (cos(position.y*20.0 + u_time*8.0) + sin(position.x*20.0 + u_time*8.0)) / 20.0;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position.x, position.y, position.z, 1.0);
}
